import apiSearch from '~/api/search';
import resources from '~/modules/resources/types';
import {promiseAction} from '~/misc/dispatch';
import resourceId from '~/misc/resourceId';
import keyBy from 'lodash/keyBy';

export default {
  [resources.RESOURCE_REQUESTED]: [
    (action, {dispatch, getState}) => {
      if (action.payload.name !== 'queriedLoads') {
        return;
      }

      const limit = action.payload.props.query;

      const skipToken = !limit || limit < 10;
      /*
        if we make request with token than request could be interpreted as auto truckposting
        no need for backhaul queries. for now request.limit < 10 means that query is not original user query
      */

      promiseAction(
        dispatch,
        getState,
        resources.RESOURCE,
        apiSearch(getState, action.payload.props.query, skipToken).then(result => {
          if (!result.shipments) {
            return result;
          }

          const list = result.shipments.map(item => ({
            ...item,
            identity: resourceId('queriedLoadsItem', {
              id: item.id,
            }, action.payload),


          }));
          return {
            ...result,
            index: keyBy(list, 'id'),
            shipments: list,
          };
        }),
        action.payload
      );
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/queriedLoads/reactions.js